import {Component, OnInit, HostListener, NgZone} from '@angular/core';
import {Address} from '../../models/address';
import {CreditCard} from '../../models/credit-card';
import {PlanModel, SalesItemModel} from '../../models/plan';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {DialogsService} from '../../services/dialog.service';
import {MatSnackBar, MatDialog} from '@angular/material';
import {Router, ActivatedRoute} from '@angular/router';
import {
  NewPolicy,
  OptionalItemInfo,
  CustomerSummary
} from '../../models/new-policy';
import {ApiAccessService} from '../../services/network/api-access.service';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';
import {Observable} from 'rxjs/Observable';
import {Http, Response} from '@angular/http';
import {
  ViewCoverageDialogComponent
} from '../../parts/plan-selection/view-coverage/view-coverage.component';
import {
  ExtendedAreaDialogComponent
} from '../../parts/plan-selection/extended-area/extended-area.component';
import {UtilitiesService} from '../../services/utilities.service';
import {NewEntity} from '../../models/new-entity';
declare var google: any;

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.css']
})
export class QuoteComponent implements OnInit {
  // address: Address = new Address();
  validatingProperty = false;
  selectedIndex = 0;
  gettingPlanSelection = false;
  planSelection: any;
  plans: PlanModel[];
  marketStates: any[] = [];
  selectedPlan: PlanModel;
  isMonthly = false;
  coverageLengths = [1, 2];
  numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  promotionCode: string;
  promotionObj: any;
  submittingOrder = false;
  shouldBeFixed = false;
  isOrdering = false;
  isSavingQuote = false;
  savingQuote = false;
  sideBar: any;
  isMultiYear = false;

  showBuyersMailingAddress = false;
  order: NewPolicy = new NewPolicy();

  titleSearchResultVisible = false;
  addTitleOfficeVisible = false;
  titleNameSearch = '';
  titleCitySearch = '';
  titlePhoneSearch = '';
  searchingForTitleCompany = false;
  titleCompanies: any[];
  newTitleCompany: NewEntity = new NewEntity();
  savingTitleCompany = false;
  selectedTitleCompany: any;
  CLOSING_DETAILS_STEP = 6;
  SUBMIT_ORDER_STEP = 7;
  escrowOfficers: any[];
  showClosingOfficers = false;
  addingNewEscrowOfficer = false;
  addingNewAgent = false;
  newClosingOfficerName = '';
  showingFindBuyersAgent = false;

  agentFirstName = '';
  agentLastName = '';
  agentLicenseNumber = '';
  agents: any[];
  newPerson: NewEntity = new NewEntity();
  branches: any[];
  findingAgents = false;
  agentSearchResultsVisible = false;
  branchSearchName = '';
  branchSearchCity = '';
  searchingForBranch = false;
  branchSearchResultVisible = false;
  addOfficeVisible = false;
  newBranch: NewEntity = new NewEntity();
  savingBranch = false;
  showAgentSearch = true;
  showBranchSearch = false;
  selectedBuyersAgent: any;
  showCreateAgentRecord = false;
  selectedBuyerBranch: any;
  savingPerson = false;

  loadingQuoteInformation = false;
  fromExistingQuote = false;
  isRealEstateCoordinator = false;
  quoteName: string;

  isEscrowUser = false;

  autocomplete;
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  };

  @HostListener('window:hashchange', ['$event'])
  watchUrlHash(event) {
    const hash = window.location.hash;

    if (hash === '#Property') {
      this.selectedIndex = 0;
    } else if (hash === '#Plan') {
      this.selectedIndex = 1;
    } else if (hash === '#Options') {
      this.selectedIndex = 2;
    } else if (hash === '#Review') {
      this.selectedIndex = 3;
    } else if (hash === '#buyersinfo') {
      this.selectedIndex = 4;
    } else if (hash === '#title') {
      this.selectedIndex = 5;
    } else if (hash === '#closing') {
      this.selectedIndex = 6;
    } else if (hash === '#submit') {
      this.selectedIndex = 7;
    } else {
      this.selectedIndex = 0;
    }
  }

  constructor(private realtorPortalService: RealtorPortalService,
    private dialogService: DialogsService,
    private snackBar: MatSnackBar, private router: Router,
    private dialog: MatDialog, private zone: NgZone,
    private route: ActivatedRoute, private snakbar: MatSnackBar) {

    if (!this.coverageLength) {
      this.coverageLength = this.realtorPortalService.getCoverageLength();
    }
  }

  ngOnInit() {

    var today = new Date();
    var cutoff = new Date(2023, 1, 1);

    if (today >= cutoff) {
      window.location.href = "https://www.ahs.com/home-warranty/oneguard-american-home-shield-partnership/";
    }

    this.order.Property.DwellingType = 'Single_Family';
    this.realtorPortalService.getSideBarInfo().then(sideBar => {
      this.sideBar = sideBar;
      this.order.EmailOrderTo = sideBar.Email;
      this.quoteName = sideBar.Name;

      if (sideBar.EntityType === 'Closing_Officer' || sideBar.EntityType === 'Closing_Officer_Coordinator') {
        this.isEscrowUser = true;
        this.order.EscrowOfficerId = sideBar.EntityId;

        this.realtorPortalService.findTitleCompanyById(sideBar.ParentEntityId)
            .then(titleCompanies => {
              this.titleCompanies = titleCompanies;
              this.selectedTitleCompany = titleCompanies[0];
              this.showClosingOfficers = true;
            });

        this.realtorPortalService.getEscrowOfficersForTitleCompany(
                                     sideBar.ParentEntityId)
            .then(escrowOfficers => { this.escrowOfficers = escrowOfficers; });
      } else if (sideBar.EntityType === 'Closing_Officer_Coordinator') {
        this.realtorPortalService.getEscrowOfficersForTitleCompany(
                                     sideBar.ParentEntityId)
            .then(escrowOfficers => { this.escrowOfficers = escrowOfficers; });
        this.isEscrowUser = true;
        this.realtorPortalService.findTitleCompanyById(sideBar.ParentEntityId)
            .then(titleCompanies => {
              console.log(titleCompanies);
              this.titleCompanies = titleCompanies;
              this.selectedTitleCompany = titleCompanies[0];
              this.showClosingOfficers = true;
            });
      } else if (sideBar.EntityType === 'Real_Estate_Office_Coordinator') {
        this.realtorPortalService.findRealEstateBranchById(
                                     sideBar.ParentEntityId)
            .then(branches => {
              this.selectedBuyerBranch = branches[0];
              if (this.selectedBuyerBranch) {
                this.realtorPortalService.getAgentsForBranch(
                                             this.selectedBuyerBranch.Id)
                    .then(agents => { this.agents = agents; });

                this.isRealEstateCoordinator = true;
              }
            });
      }
    });
    this.realtorPortalService.getMarketStates().then(
        marketStates => { this.marketStates = marketStates; });



    this.route.params.subscribe(params => {
      // this.quoteId = params['id'];
      if (params['quoteId']) {
        this.loadingQuoteInformation = true;
        this.fromExistingQuote = true;
        this.realtorPortalService.getWebQuote(params['quoteId'])
            .then(webQuote => {

              this.order = webQuote;

              console.log(this.order);

              this.isMonthly = this.order.IsMonthly;

              if (this.sideBar && !this.order.EmailOrderTo) {
                this.order.EmailOrderTo = this.sideBar.Email;
              }

              this.getPlanSelection(() => {
                this.selectedPlan =
                    this.plans.filter(i => i.id === webQuote.PlanId)[0];


                if (this.selectedPlan) {
                  this.isOrdering = true;
                  this.selectedIndex = 3;
                  if (webQuote.Options) {
                    webQuote.Options.forEach(option => {
                      const oi = this.selectedPlan.optionalItems.filter(
                          i => i.planItemId === option.Id)[0];
                      if (oi) {
                        if (oi.selected) {
                          oi.quantity++;
                        } else {
                          oi.selected = true;
                        }
                      }
                    });
                  }

                  if (webQuote.CouponCode) {
                    this.promotionCode = webQuote.CouponCode;
                    this.loadPromotionCode(
                        () => { this.loadingQuoteInformation = false; });
                  } else {
                    this.loadingQuoteInformation = false;
                  }
                } else {
                  // The plan the originally chose is no longer valid
                  this.selectedIndex = 1;
                  this.loadingQuoteInformation = false;
                }
              });
            });
      }
    });
  }


  onStepChange() {
    if (this.selectedIndex === 0) {
      window.location.hash = 'Property';
    } else if (this.selectedIndex === 1) {
      window.location.hash = 'Plan';
    } else if (this.selectedIndex === 2) {
      window.location.hash = 'Options';
    } else if (this.selectedIndex === 3) {
      window.location.hash = 'Review';
    } else if (this.selectedIndex === 4) {
      window.location.hash = 'buyersinfo';
    } else if (this.selectedIndex === 5) {
      window.location.hash = 'title';
    } else if (this.selectedIndex === 6) {
      window.location.hash = 'closing';
    } else if (this.selectedIndex === 7) {
      window.location.hash = 'submit';
    }

    this.showingFindBuyersAgent = false;
    this.showAgentSearch = true;
    this.agentSearchResultsVisible = false;
    this.showBranchSearch = false;
    this.branchSearchResultVisible = false;
    this.addOfficeVisible = false;
    this.showCreateAgentRecord = false;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // this.shouldBeFixed = window.scrollY > 1;
  }

  get selectedOptions() {
    const results = [];

    if (this.selectedPlan) {
      this.selectedPlan.optionalItems.forEach(oi => {
        if (oi.selected) {
          for (let i = 0; i < oi.quantity; i++) {
            results.push({
              name: oi.name,
              price: this.isMonthly ? oi.priceRecurring : oi.price,
              planItemId: oi.planItemId,
              fullPrice: oi.price,
              priceRecurring: oi.priceRecurring,
            });
          }
        }
      });
    }
    return results;
  }

  get basePrice() {
    if (!this.selectedPlan) {
      return 0;
    }
    return this.isMonthly ? this.selectedPlan.priceRecurring :
                            this.selectedPlan.price;
  }

  get canSearchForTitleCompany() {
    return (this.titleNameSearch && this.titleCitySearch) ||
           (this.titlePhoneSearch &&
            UtilitiesService.isValidPhoneNumber(this.titlePhoneSearch));
  }

  get canSaveTitleCompany() {
    return this.newTitleCompany.Name && this.newTitleCompany.StreetAddress &&
           this.newTitleCompany.City && this.newTitleCompany.State &&
           this.newTitleCompany.ZipCode && this.newTitleCompany.Phone &&
           UtilitiesService.isValidPhoneNumber(this.newTitleCompany.Phone);
  }

  get selectedClosingOfficer() {
    if (!this.escrowOfficers) {
      return null;
    }

    return this.escrowOfficers.filter(i => i.Id ===
                                           this.order.EscrowOfficerId)[0];
  }

  get selectedClosingOfficerName() {
    const ci = this.selectedClosingOfficer;
    return ci == null ? null : ci.Name;
  }

  get canGoToClosingInfo() { return this.order.EscrowOfficerId; }



  get canSearchForAgent() {
    return this.agentLicenseNumber ||
           (this.agentFirstName && this.agentLastName);
  }

  get canSearchForBranch() {
    return this.branchSearchName && this.branchSearchCity;
  }

  get canSaveBranch() {
    return this.newBranch.Name && this.newBranch.StreetAddress &&
           this.newBranch.City && this.newBranch.State &&
           this.newBranch.ZipCode && this.newBranch.Phone &&
           UtilitiesService.isValidPhoneNumber(this.newBranch.Phone);
  }

  searchForAgent() {
    this.findingAgents = true;
    this.realtorPortalService.findAgentByName(this.agentFirstName,
                                              this.agentLastName,
                                              this.agentLicenseNumber)
      .then(agents => {

          this.findingAgents = false;
          this.agents = agents;
          this.agentSearchResultsVisible = true;
          this.showAgentSearch = false;
        });
  }

  searchForBranch() {
    this.searchingForBranch = true;
    this.realtorPortalService.findBranchByNameAndCity(this.branchSearchName,
                                                      this.branchSearchCity)
        .then(branches => {
          this.searchingForBranch = false;
          this.branches = branches;
          this.branchSearchResultVisible = true;
          this.showBranchSearch = false;
        });
  }

  saveNewBranch() {
    this.savingBranch = true;
    this.realtorPortalService.saveNewBranch(this.newBranch)
        .then(result => {
          this.setRealEstateBranch(this.newBranch);
          this.savingBranch = false;
          this.addOfficeVisible = false;
        });
  }

  setRealEstateBranch(realEstateBranch) {
    this.showCreateAgentRecord = true;
    this.selectedBuyerBranch = realEstateBranch;
    this.branchSearchResultVisible = false;
  }

  setAgent(agent) {
    this.order.BuyersAgentId = agent.Id;
    this.selectedBuyersAgent = agent;
    this.showingFindBuyersAgent = false;
    this.selectedIndex++;
  }

  get canSavePerson() { return this.newPerson.Name; }

  savePerson() {
    this.savingPerson = true;
    this.newPerson.ParentId = this.selectedBuyerBranch.Id;
    this.realtorPortalService.saveAgent(this.newPerson)
        .then(() => {
          this.setAgent(this.newPerson);
          this.savingPerson = false;
        });
  }



  addNewClosingOfficer() {
    const newEntity = new NewEntity();
    newEntity.Id = UtilitiesService.newid();
    newEntity.Name = this.newClosingOfficerName;
    newEntity.ParentId = this.selectedTitleCompany.Id;

    if (this.addingNewAgent) {
      newEntity.ParentId = this.selectedBuyerBranch.Id;
      this.realtorPortalService.saveAgent(newEntity).then(() => {
        this.escrowOfficers.push(newEntity);
        this.order.BuyersAgentId = newEntity.Id;
        this.addingNewEscrowOfficer = false;
        this.addingNewAgent = false;
        this.agents.push(newEntity);
        this.selectedBuyersAgent = newEntity;
      });
    } else {
      this.realtorPortalService.saveClosingOfficer(newEntity).then(() => {
        this.escrowOfficers.push(newEntity);
        this.order.EscrowOfficerId = newEntity.Id;
        this.addingNewEscrowOfficer = false;
        this.addingNewAgent = false;
      });
    }
  }

  saveNewTitleCompany() {
    this.savingTitleCompany = true;
    this.realtorPortalService.saveNewTitleCompany(this.newTitleCompany)
        .then(result => {
          this.setTitleCompany(this.newTitleCompany);
          this.savingTitleCompany = false;

        });
  }

  setTitleCompany(titleCompany) {
    this.selectedTitleCompany = titleCompany;
    this.addTitleOfficeVisible = false;
    // this.selectedIndex = this.CLOSING_DETAILS_STEP;
    this.realtorPortalService.getEscrowOfficersForTitleCompany(titleCompany.Id)
        .then(escrowOfficers => {
          this.escrowOfficers = escrowOfficers;
          this.showClosingOfficers = true;
        });
  }

  searchForTitleCompany() {
    this.searchingForTitleCompany = true;

    if (this.titleNameSearch && this.titleCitySearch) {
      this.realtorPortalService.findTitleCompanyByNameAndCity(
                                   this.titleNameSearch, this.titleCitySearch)
          .then(titleCompanies => {
            this.searchingForTitleCompany = false;
            this.titleCompanies = titleCompanies;
            this.titleSearchResultVisible = true;
          });
    } else {
      this.realtorPortalService.findTitleCompanyByPhone(this.titlePhoneSearch)
          .then(titleCompanies => {
            this.searchingForTitleCompany = false;
            this.titleCompanies = titleCompanies;
            this.titleSearchResultVisible = true;
          });
    }
  }

  get orderTotal(): number {
    if (!this.selectedPlan) {
      return 0;
    }

    let price = this.basePrice;

    if (this.promotionObj) {
      price += this.isMonthly ? this.promotionObj.MonthlyAmount :
                                this.promotionObj.Amount;
    }

    this.selectedOptions.forEach(si => { price += si.price; });
    if (!this.isMonthly)
      price *= this.coverageLength;

    return price;
  }

  get yearlyTotal(): number {
    if (!this.selectedPlan) {
      return 0;
    }

    let price = this.basePrice;

    if (this.promotionObj) {
      price += this.isMonthly ? this.promotionObj.MonthlyAmount :
        this.promotionObj.Amount;
    }

    this.selectedOptions.forEach(si => { price += si.price; });

    return price;
  }

  get firstPayment(): number {
    if (!this.isMonthly) {
      return 0;
    }

    return this.orderTotal * 2;
  }

  get canSubmitOrder() { return this.selectedPlan; }

  get buyerCanGoNextStep() {
    return this.customer.FirstName && this.customer.Email &&
           UtilitiesService.isEmailValid(this.customer.Email) &&
           UtilitiesService.isValidPhoneNumber(this.customer.HomePhone) &&
           (!this.showBuyersMailingAddress ||
            (

                this.customer.MailingAddress && this.customer.MailingCity &&
                this.customer.MailingState && this.customer.MailingZip));
  }

  get closingCanGoNextStep() {
    return this.order.EscrowResponsibleParty
  }

  startOrderProcess() {
    this.isOrdering = true;
    this.isSavingQuote = false;
    this.selectedIndex = 4;
  }

  startSaveQuote() {
    this.isOrdering = false;
    this.isSavingQuote = true;
    this.selectedIndex = 4;
  }

  private saveOptionsToOrder() {
    const results = [];

    if (this.selectedPlan) {
      this.order.PlanId = this.selectedPlan.id;
      this.order.PlanName = this.selectedPlan.name;
      this.order.PlanPrice = this.basePrice;
      this.order.IsMonthly = this.isMonthly;

      this.selectedPlan.optionalItems.forEach(oi => {
        if (oi.selected) {
          for (let i = 0; i < oi.quantity; i++) {
            const optionalItem = new OptionalItemInfo();

            optionalItem.Name = oi.name;
            optionalItem.AllowMultiple = oi.allowQuantity;
            optionalItem.FullPrice = oi.price;
            optionalItem.Id = oi.planItemId;
            optionalItem.MonthPrice = oi.priceRecurring;
            optionalItem.Name = oi.name;
            optionalItem.SalesItemCoverageId = oi.salesItemCoverageId;
            optionalItem.InSelectAreas = oi.inSelectAreas;
            optionalItem.SalesItemId = oi.salesItemId;


            results.push(optionalItem);
          }
        }
      });
      if (this.promotionObj) {
        this.order.CouponCode = this.promotionObj.code;
        const couponItem = new OptionalItemInfo();
        couponItem.Name = this.promotionObj.Description;
        couponItem.FullPrice = this.promotionObj.Amount;
        couponItem.MonthPrice = this.promotionObj.MonthlyAmount;
        results.push(couponItem);
      }
    }

    this.order.Options = results;
  }

  saveWebQuote() {
    this.saveOptionsToOrder();
    this.savingQuote = true;
    this.realtorPortalService.saveWebQuote(this.order)
        .then(results => {
          this.router.navigateByUrl('/home');
          this.savingQuote = false;
          this.snakbar.openFromComponent(ToastSuccessComponent, {
            data: 'Your quote has been saved. Thank You.',
            duration: 10000,
            panelClass: ['success-toast']
          });
        });
  }

  get customer(): CustomerSummary {
    return this.order.SellersCoverage ? this.order.Seller : this.order.Buyer;
  }

  submitOrder() {
    this.saveOptionsToOrder();
    this.submittingOrder = true;
    const newPolicy = this.order;

    if (!this.order.BuyersAgentId) {

      if (this.selectedBuyersAgent && this.selectedBuyersAgent.Id) {

        this.order.BuyersAgentId = this.selectedBuyersAgent.Id;

      }
      else if (this.sideBar.EntityType === 'Agent' && !this.order.SellersCoverage) {
        newPolicy.BuyersAgentId = this.sideBar.EntityId;
      }
      else {
        this.order.BuyersAgentId = null;
      }
    }

    this.order.SellersCoverage ? newPolicy.InitiatingAgentType = 'Listing' :
                                 newPolicy.InitiatingAgentType = 'Selling';

    newPolicy.IsMonthly = this.isMonthly;
    newPolicy.Options = this.selectedOptions.map(o => {
      const oi = new OptionalItemInfo();
      oi.FullPrice = o.fullPrice;
      oi.MonthPrice = o.priceRecurring;
      oi.Id = o.planItemId;
      oi.Name = o.name;
      return oi;
    });

    newPolicy.PlanId = this.selectedPlan.id;
    newPolicy.CoverageLength = this.coverageLength;

    this.realtorPortalService.saveNewPolicy(newPolicy).then(result => {
      this.submittingOrder = false;
      this.router.navigateByUrl('/order/' + result);
    });
  }

  loadPromotionCode(callback: any = null) {
    this.realtorPortalService.getPromotion(this.promotionCode)
        .then(promotion => {

          if (promotion) {
            this.promotionObj = promotion;
            this.promotionObj.code = this.promotionCode;
            this.promotionCode = '';
          } else {
            this.dialogService.alert(
                'Not Found', 'Sorry, we could not find that promotion code.');
          }
          if (callback) {
            callback();
          }
        });
  }

  selectedPlanChange() {
    this.selectedIndex = 2;
    if (this.selectedPlan) {
      this.order.PlanId = this.selectedPlan.id;
      this.selectedPlan.coverageLength = this.coverageLength;
    }
  }

  goToReview() { this.selectedIndex = 3; }

  get canGoNextPropertyStep() {
    return this.order.Property.Address && this.order.Property.City &&
           this.order.Property.State && this.order.Property.Zip &&
           this.order.Property.DwellingType;
  }

  showCoverage(item) {
    this.dialog.open(ViewCoverageDialogComponent,
                     {data: item.salesItemCoverageId});
  }

  showExtendedArea(state) {
    this.dialog.open(ExtendedAreaDialogComponent,
      { data: state });
  }

  propertyNext() {
    this.validatingProperty = true;
    this.realtorPortalService.validateAddress(this.order.Property)
        .then(results => {
          console.log(results);
          this.validatingProperty = false;
          if (!results.IsValid) {
            if (results.Message === 'NOT_FOUND') {
              this.dialogService.alert(
                  'Not Found',
                  'Sorry, the address you provided was either not found or outside of our service area.');
            } else if (results.Message === 'ADDRESS_EXISTS') {
              this.dialogService.alert(
                  'Address Exists',
                  'It looks like there is already active OneGuard coverage for that property.<br><br>  Please give us a call at 888.896.0014.');
            }
          } else {
            this.selectedIndex = 1;

            this.gettingPlanSelection = true;
            this.order.Property.SquareFootage = results.SquareFootage;
            this.order.Property.YearBuilt = results.YearBuilt;
            if (!this.order.Property.SquareFootage) {
              this.order.Property.SquareFootage = 1;
            }
            if (!this.order.Property.YearBuilt) {
              this.order.Property.YearBuilt = new Date().getFullYear();
            }
            this.getPlanSelection();
          }
        });
  }

  toggleSellersCoveragePlans() {
    this.order.SellersCoverage = !this.order.SellersCoverage;
    this.gettingPlanSelection = true;
    this.getPlanSelection(() => this.gettingPlanSelection = false);
  }

  private getPlanSelection(callback: any = null) {
    const transformedPlans = [];

    const planColors = ['#286DA8', '#CD5360', '#B37D4E', '#438496', 'violet', 'orange'];
    this.realtorPortalService.getPlanSelection(this.order.Property,
                                               this.order.SellersCoverage)
        .then(planSelection => {
          console.log(planSelection);
          if (planSelection.Error) {
            const ref =
                this.dialogService.alert('Cannot Order', planSelection.Error);

            ref.subscribe(() => {
              this.gettingPlanSelection = false;
              this.selectedIndex = 0;
            });

            return;
          }
          planSelection.Plans = planSelection.Plans.sort(
              (a, b) => a.FullPrice > a.FullPrice ? 0 : 1);
          this.gettingPlanSelection = false;
          this.planSelection = planSelection;
          planSelection.Plans.forEach(plan => {
            const planModel = new PlanModel();
            planModel.id = plan.PlanId;
            planModel.monthlyProcessingFee = plan.MonthlyCCFee;
            planModel.name = plan.Name;
            planModel.optionalItems = [];

            planModel.planColor = planColors[planSelection.Plans.indexOf(plan)];
            planModel.price = plan.FullPrice;
            planModel.priceRecurring = plan.MonthlyPrice;
            planModel.serviceFee = plan.ServiceFee;
            planModel.standardItems = [];

            if (planModel.name.indexOf('Guardian') > -1) {
              planModel.summary =
                'Comprehensive Coverage<br>+  Preferred Upgrade<br>+  Washer/Dryer, Fridge';
              planModel.isBestValue = true;
            } else if (planModel.name.indexOf('Centurion') > -1) {
              planModel.summary =
                  'Comprehensive Coverage<br> +  Preferred Upgrade';
            } else if (planModel.name.indexOf('Sentinel') > -1) {
              planModel.summary = 'Comprehensive Coverage';
            }

            plan.StandardItems.forEach(si => {
              const newSalesItem = new SalesItemModel();
              newSalesItem.allowQuantity = si.AllowMultiple;
              newSalesItem.category = si.Category;
              newSalesItem.name = si.Name;
              newSalesItem.planItemId = si.Id;
              newSalesItem.price = si.FullPrice;
              newSalesItem.priceRecurring = si.MonthPrice;
              newSalesItem.salesItemCoverageId = si.SalesItemCoverageId;
              newSalesItem.inSelectAreas = si.InSelectAreas;
              newSalesItem.salesItemId = si.SalesItemId;

              planModel.standardItems.push(newSalesItem);
            });

            plan.OptionalItems.forEach(si => {
              const newSalesItem = new SalesItemModel();
              newSalesItem.allowQuantity = si.AllowMultiple;
              newSalesItem.category = si.Category;
              newSalesItem.name = si.Name;
              newSalesItem.planItemId = si.Id;
              newSalesItem.price = si.FullPrice;
              newSalesItem.priceRecurring = si.MonthPrice;
              newSalesItem.salesItemCoverageId = si.SalesItemCoverageId;
              newSalesItem.inSelectAreas = si.InSelectAreas;
              newSalesItem.salesItemId = si.SalesItemId;
              newSalesItem.requirements = si.Requirements;

              planModel.optionalItems.push(newSalesItem);
            });

            transformedPlans.push(planModel);
          });

          this.plans = transformedPlans;

          if (callback) {
            callback();
          }

        });
  }

  areRequirementsMet(item) {
    if (!item.requirements) {
      return true;
    }

    const results = this.checkRequirement(item.requirements);

    if (!results) {
      item.selected = false;
    }
    return results;
  }

  checkRequirement(requirement) {
    try {
      if (requirement.Operator) {
        if (requirement.Operator.toUpperCase() === 'OR') {
          for (let i = 0; i < requirement.Operands.length; i++) {
            const result1 = this.checkRequirement(requirement.Operands[i]);
            if (result1) {
              return true;
            }
          }
        } else if (requirement.Operator.toUpperCase() === 'AND') {
          for (let i = 0; i < requirement.Operands.length; i++) {
            const result1 = this.checkRequirement(requirement.Operands[i]);
            if (!result1) {
              return false;
            }
          }
          return true;
        } else {
          alert('Requirements Operator ' + requirement.Operator.toUpperCase() +
                ' has not been implemented.');
          return false;
        }
      } else if (requirement.SalesItemId) {
        for (let i2 = 0; i2 < this.selectedPlan.standardItems.length; i2++) {
          if (this.selectedPlan.standardItems[i2].salesItemId ===
              requirement.SalesItemId) {
            return true;
          }
        }

        for (let i = 0; i < this.selectedPlan.optionalItems.length; i++) {
          const oi = this.selectedPlan.optionalItems[i];
          if (oi.selected && oi.salesItemId === requirement.SalesItemId) {
            return true;
          }
        }
      } else {
        alert(
            'Requirement exists that does not include an Operator or a SalesItemId');
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  checkZipCode() {
    setTimeout(() => {
      if (this.order.Property.Zip != null &&
          this.order.Property.Zip.length === 5) {
        this.realtorPortalService.getZipCodeInfo(this.order.Property.Zip)
            .then(data => {
              if (data.status === 'OK' && data.results.length > 0) {
                const result = data.results[0];

                for (let i = 0; i < result.address_components.length; i++) {
                  const component = result.address_components[i];
                  if (component.types.indexOf('locality') > -1) {
                    this.order.Property.City = component.long_name;
                  }
                  if (component.types.indexOf('administrative_area_level_1') >
                      -1) {
                    const selectedState = this.marketStates.filter(
                        ii => ii.StateAbbreviation === component.short_name)[0];
                    if (selectedState != null) {
                      this.order.Property.State = component.short_name;
                    }
                  }
                }
              }
            });
      }
    });
  }

  private extractData(res: Response) {
    const body = res.json();
    return body.results || {};
  }

  private _coverageLength: any;
  get coverageLength(): any { return this._coverageLength; }
  set coverageLength(value) {
    this._coverageLength = value;
    if (!this.coverageLength)
      return;
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  geoLocate() {
    this.initAutocomplete();
    // bias toward az locations
    const geolocation = {lat: 33.6816772, lng: -112.1103491};
    const circle = new google.maps.Circle({
      center: geolocation,
      radius: 1000,
    });
    this.autocomplete.setBounds(circle.getBounds());
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete'), {types: ['geocode']});

    this.autocomplete.addListener('place_changed', () => this.fillInAddress());
  }

  fillInAddress() {
    const place = this.autocomplete.getPlace();
    if (!place) {
      return;
    }
    this.zone.run(() => {
      let street = '';
      let route = '';
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (addressType === 'street_number') {
          street = place.address_components[i][this.componentForm[addressType]];
        } else if (addressType === 'route') {
          route = place.address_components[i][this.componentForm[addressType]];
        } else if (addressType === 'locality') {
          this.order.Property.City =
              place.address_components[i][this.componentForm[addressType]];
        } else if (addressType === 'administrative_area_level_1') {
          this.order.Property.State =
              place.address_components[i][this.componentForm[addressType]];
        } else if (addressType === 'country') {
          this.order.Property.Country =
              place.address_components[i][this.componentForm[addressType]];
        } else if (addressType === 'postal_code') {
          this.order.Property.Zip =
              place.address_components[i][this.componentForm[addressType]];
        }
      }

      // Clearing and resetting the address fixes a small rendering bug with the
      // google address suggestion
      this.order.Property.Address = '';
      setTimeout(() => { this.order.Property.Address = street + ' ' + route; });
    });
  }
}
